module.exports = __webpack_public_path__ + "static/media/market.f468fa10.png";